import * as dialog from 'plugins/dialog';

import BaseModal from '@/legacy/modals/BaseModal';

declareModules({
  'modals/styled/titleMessageLink.html': () =>
    import('@/legacy/modals/styled/titleMessageLink.html'),
});

interface ViewModelParams {
  title: string;

  message?: string;
  messageHtml?: string;

  continueText?: string;

  optionText?: string;
  optionLink: string;
  /**
   * Displayed as a button by default
   */
  optionAsLink?: boolean;
  /**
   * If specified do not navigate to optionLink and instead call this callback
   **/
  optionCallback?: () => void;

  svgIcon?: string;
  svgIconSymbol?: string;
  svgIconSymbolLarge?: string;
}

class StyledModal extends BaseModal {
  view = 'modals/styled/titleMessageLink';

  public params: ViewModelParams;

  public continueText: string;

  public optionText: string;

  public optionLink: string;

  public optionCallback: () => void;

  public classes = {
    option: 'btn btn-block btn-lg btn-primary',
    cta: 'btn-secondary',
  };

  constructor(params: ViewModelParams) {
    super();
    this.params = params;
    this.continueText = params.continueText ? params.continueText : 'Close';
    this.optionText = params.optionText ? params.optionText : 'Continue';
    this.optionLink = params.optionLink;
    this.optionCallback = params.optionCallback;

    if (params.optionAsLink) {
      this.classes.option = '';
      this.classes.cta = 'btn-primary';
    }
  }

  public close(): void {
    dialog.close(this, false);
  }

  public selectOption(e: Event) {
    if (this.optionCallback) {
      this.optionCallback();
      dialog.close(this, true);
      return false; // Don't follow the link href
    }

    dialog.close(this, true);
    return true;
  }

  public static show(params: ViewModelParams): JQueryPromise<any> {
    return dialog.show(new StyledModal(params));
  }
}

export default StyledModal;
